/*
  RK: gedrag van de eigen winkelwagen-lade - vervangt de UpCart-app.

  WAT DIT BESTAND WEL DOET
  - het blok "vaak samen gekocht" in de lade: bijpassende producten ophalen en
    tonen, met de twee pijltjes eromheen;
  - de productlade die daarover heen schuift zodra je op een aanbeveling tikt:
    foto's, kleur, maat, toevoegen, beschrijving (zie qvOpen);
  - diezelfde productlade onder COMPLETE THE LOOK op de productpagina (zie
    initLook);
  - min tot 0 = artikel uit de wagen, in de lade en op de /cart-pagina;
  - de lade opnieuw inlezen nadat er iets aan de wagen verandert.

  HET KORTINGSCODEVELD IS ERUIT. Dat stond hier ook; Ramin wilde het weg omdat
  het in de lade meer ruimte kostte dan het opleverde. Wie een code heeft vult
  hem in de checkout in. Terughalen? Het zat in deze functie: initDiscount(),
  zie de versiegeschiedenis van dit bestand.

  WAT DIT BESTAND NIET DOET, EN WAAROM NIET
  - Open- en dichtschuiven, de toetsenbordval en het sluiten op Escape: dat
    doet assets/cart-drawer.js van Dawn al, en de koptekst en de koopknop
    hangen daaraan vast. Niet overdoen.
  - Aantal wijzigen en artikelen verwijderen: dat doet assets/cart.js van
    Dawn (CartItems / cart-remove-button). Die vervangt na elke wijziging de
    HELE .drawer__inner met een verse versie van de sectie cart-drawer. Dat
    is precies waarom de spaarbalk, de kortingsregels en het totaal in
    Liquid staan en niet in dit bestand: ze komen na elke plus/min vanzelf
    kloppend terug van de server, zonder dat hier iets hoeft te rekenen.
    Zet die berekening hier dus niet alsnog neer.
  - De korting zelf toekennen. De 10%/15% zijn gewone automatic discounts in
    Shopify; die rekent Shopify door. Wij laten alleen zien hoe ver je bent.

  DE PRIJZEN IN HET UPSELL-BLOK
  De aanbevelingen komen als JSON binnen, met bedragen in centen en zonder
  opmaak. Daarom staat hier een kleine formatter die het geldformaat van de
  winkel (shop.money_format, meegegeven vanuit Liquid) toepast - zo staat er
  overal in de winkel exact dezelfde notatie, ook bij een andere valuta of
  een ander scheidingsteken.

  ALLE TEKST KOMT UIT DE TAAL-EDITOR. Niets staat hier hardcoded: de losse
  teksten worden als data-attribuut vanuit snippets/cart-drawer.liquid
  meegegeven. Voeg hier dus nooit een zin toe, maar een sleutel.

  METING: WAT LEVERT DE UPSELL OP?
  Alles wat via de productlade van de upsell in de wagen komt, krijgt het
  verborgen kenmerk _rk_source = cart-upsell mee (zie UPSELL_SOURCE). Omdat
  het met een _ begint ziet de klant het nergens - niet in de lade, niet op
  /cart en niet in de checkout - maar het staat wel op de orderregel. Een
  dagelijkse taak telt die regels op. Haal dit dus niet weg en verander de
  naam niet, anders telt de meting niets meer.
*/
(() => {
  if (window.__rkCartDrawer) return;
  window.__rkCartDrawer = true;

  const SEL_ROOT = 'cart-drawer';

  /* Technische waarde voor de meting, geen tekst voor de klant - zie het
     kopje METING bovenaan. */
  const UPSELL_SOURCE = { _rk_source: 'cart-upsell' };

  function shopRoot() {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* ----------------------------------------------------------
     Geld opmaken volgens het formaat van de winkel.
     ---------------------------------------------------------- */
  function formatMoney(cents, fmt) {
    const value = (Number(cents) || 0) / 100;

    function grouped(decimals, thousands, decimal) {
      const parts = value.toFixed(decimals).split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? int + decimal + parts[1] : int;
    }

    if (!fmt) return grouped(2, '.', ',');

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
      switch (name) {
        case 'amount':
          return grouped(2, ',', '.');
        case 'amount_no_decimals':
          return grouped(0, ',', '.');
        case 'amount_with_comma_separator':
          return grouped(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return grouped(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return grouped(2, "'", '.');
        case 'amount_with_space_separator':
          return grouped(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return grouped(0, ' ', ',');
        default:
          return match;
      }
    });
  }

  /* ----------------------------------------------------------
     De lade opnieuw inlezen van de server.

     Eén bron van waarheid: de sectie cart-drawer. We halen 'm op en zetten
     de binnenkant erin, net zoals Dawn dat zelf doet bij een plus/min. Zo
     kloppen spaarbalk, kortingen en totaal altijd, en hoeft hier niets te
     worden bijgehouden.
     ---------------------------------------------------------- */
  let refreshing = null;

  function refresh() {
    if (refreshing) return refreshing;

    const root = shopRoot();

    refreshing = fetch(`${root}?section_id=cart-drawer`, { credentials: 'same-origin' })
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const srcInner = doc.querySelector('.drawer__inner');
        const dstInner = document.querySelector(`${SEL_ROOT} .drawer__inner`);
        if (srcInner && dstInner) dstInner.innerHTML = srcInner.innerHTML;

        const srcDrawer = doc.querySelector(SEL_ROOT);
        const dstDrawer = document.querySelector(SEL_ROOT);
        if (srcDrawer && dstDrawer) {
          dstDrawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
        }
      })
      .then(() => fetch(`${shopRoot()}?section_id=cart-icon-bubble`, { credentials: 'same-origin' }))
      .then((res) => res.text())
      .then((text) => {
        /* Het aantal-bolletje in de koptekst hoort meteen mee te lopen,
           anders staat er 2 terwijl er 3 in de wagen liggen. */
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const src = doc.querySelector('.shopify-section') || doc.body;
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(() => {
        /* Stil falen: de lade blijft staan zoals hij stond. Een mislukte
           verversing mag nooit de knop onbruikbaar maken. */
      })
      .finally(() => {
        refreshing = null;
      });

    return refreshing;
  }

  /* ----------------------------------------------------------
     UPSELL
     ---------------------------------------------------------- */

  /* Het plusje op de fototegel - zie het comment bij buildCard. Het pijltje
     van het oude keuzevakje (CARET) is hier weg: dat vakje bestaat niet meer,
     de keuzelijst zit nu onzichtbaar onder dit plusje. */
  const PLUS =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  const ARROW_PREV =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ARROW_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ----------------------------------------------------------
     DE BROEK (EN DE HOODIE) IN DEZELFDE KLEUR

     Wat Ramin wilde: ligt er een Football Heritage-artikel in de wagen, dan
     staat de SWEATPANTS in "vaak samen gekocht" - en wel in dezelfde kleur.
     Grijze hoodie in de wagen = grijze broek, roze = roze, en als er niets
     past: zwart. Ligt er een shirt of longsleeve in de wagen, dan komt de
     hoodie van datzelfde ontwerp er ook bij.

     WAAROM DIT NIET UIT DE AANBEVELINGEN KOMT
     /recommendations/products.json geeft hooguit het PRODUCT terug, niet de
     kleur - en of de broek er uberhaupt tussen staat bepaalt Shopify. Deze
     twee zetten we er daarom zelf voor, en de rest van de rij blijven de
     gewone aanbevelingen.

     AUTOMATISCH, OOK VOOR PRODUCTEN DIE ER NOG NIET ZIJN
     Er staat hier geen lijst met producten of kleuren. De broek wordt bij
     zijn handle opgezocht (LOOK_PANTS_HANDLE, de enige regel die je hier ooit
     hoeft aan te passen - namelijk als er ooit een andere broek komt) en de
     kleuren komen uit het product zelf. Zet je morgen een nieuw Football
     Heritage-shirt in de winkel, dan werkt dit er meteen voor.

     DE HOODIE WORDT GEVONDEN OP ZIJN HANDLE
     Die van een shirt is dezelfde handle met -hoodie erachter, soms met -1
     omdat Shopify er al een had (gemeten in de winkel:
     ronaldo-psv-t-shirt -> ronaldo-psv-hoodie,
     football-heritage-ronaldinho -> football-heritage-ronaldinho-hoodie,
     football-heritage-ronaldo -> football-heritage-ronaldo-hoodie-1).
     HOU DIE NAAMGEVING AAN bij een nieuwe hoodie, anders wordt hij niet
     gevonden - er gaat dan niets stuk, er komt alleen geen hoodie in de rij.
     ---------------------------------------------------------- */

  /* De broek. De enige vaste naam in dit blok. */
  const LOOK_PANTS_HANDLE = 'football-heritage-sweatpants';

  /* Hieraan herkennen we een Football Heritage-artikel. */
  const LOOK_FAMILY = /football[\s-]?heritage/i;

  /* Kledingwoorden die in een KLEURNAAM kunnen staan ("Pink T-Shirt") en bij
     het vergelijken niet meetellen. */
  const LOOK_GARMENT = /\b(t[\s-]?shirts?|tshirts?|tees?|longsleeves?|long sleeves?|hoodies?|sweaters?|sweatshirts?|sweatpants|pants|shirts?)\b/gi;

  const lookCache = Object.create(null);

  function lookNorm(value) {
    return String(value || '')
      .toLowerCase()
      .replace(LOOK_GARMENT, ' ')
      .replace(/[^a-z]+/g, ' ')
      .trim();
  }

  /* Op welke plek staat de kleur bij dit product? /products/<handle>.js geeft
     options als objecten terug, de aanbevelingen-JSON als losse woorden - zie
     het comment bij qvFill. Allebei afgevangen. De namen zijn vertaald, dus
     niet alleen op "color" zoeken. */
  function colorNames(product) {
    return ((product && product.options) || []).map((o) => (o && typeof o === 'object' ? o.name : o));
  }

  function colorIndexOf(names) {
    for (let i = 0; i < names.length; i += 1) {
      if (/colou?r|kleur|farbe|couleur|colore|\bcor\b/i.test(String(names[i]))) return i;
    }
    return -1;
  }

  function colorValuesOf(product) {
    const i = colorIndexOf(colorNames(product));
    const out = [];
    if (i < 0) return out;
    ((product && product.variants) || []).forEach((v) => {
      const value = v['option' + (i + 1)];
      if (value && out.indexOf(value) === -1) out.push(value);
    });
    return out;
  }

  /*
    WELKE KLEUR VAN DIT PRODUCT PAST BIJ DE KLEUR UIT DE WAGEN?

    Drie stappen, van streng naar soepel:
      1. precies dezelfde naam        "Grey" (hoodie)        -> "Grey"
      2. hetzelfde kleurwoord         "Pink T-Shirt"         -> "Light Pink"
                                      "Dark Grey Longsleeve" -> "Grey"
      3. niets gevonden               "Khaki T-Shirt"        -> "" (= zwart)

    Maten komen hier ook langs (de wagen geeft alle optiewaarden mee); "M" of
    "XXL" levert nooit een treffer op, dus die vallen vanzelf af.
  */
  function matchColor(product, wanted) {
    const values = colorValuesOf(product);
    const want = lookNorm(wanted);
    if (!values.length || !want) return '';

    let hit = values.find((v) => lookNorm(v) === want);
    if (hit) return hit;

    const words = want.split(' ');
    const head = words[words.length - 1];
    if (head && head.length > 2) {
      hit = values.find((v) => lookNorm(v).split(' ').indexOf(head) !== -1);
      if (hit) return hit;
    }
    return '';
  }

  /* De kleur die de klant in de wagen heeft, vertaald naar een kleur van dit
     product. Lukt dat niet, dan zwart - en bestaat zwart hier niet, dan laat
     buildCard gewoon de eerste leverbare variant zien. */
  function pickColor(product, values) {
    for (let i = 0; i < values.length; i += 1) {
      const hit = matchColor(product, values[i]);
      if (hit) return hit;
    }
    return matchColor(product, 'black');
  }

  function lookFetch(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(lookCache, handle)) {
      return Promise.resolve(lookCache[handle]);
    }
    return fetch(`${shopRoot()}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
    })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
      .then((product) => {
        lookCache[handle] = product;
        return product;
      });
  }

  /* De handle van de hoodie die bij dit shirt hoort - zie het comment boven. */
  function hoodieHandles(handle) {
    const stam = String(handle || '').replace(/-(t-?shirts?|tees?|longsleeves?)$/i, '');
    return [stam + '-hoodie', stam + '-hoodie-1'];
  }

  /*
    De twee kaarten die we er zelf voor zetten.

    Het eerste artikel in de wagen is het vertrekpunt - hetzelfde artikel dat
    ook de aanbevelingen bepaalt (data-rk-seed in snippets/cart-drawer.liquid),
    zodat de rij over een en hetzelfde artikel gaat.
  */
  function lookCards(inCart) {
    return fetch(`${shopRoot()}cart.js`, { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        const item = ((cart && cart.items) || [])[0];
        if (!item) return [];

        const handle = item.handle || '';
        const titel = item.product_title || item.title || '';
        if (!LOOK_FAMILY.test(handle + ' ' + titel)) return [];

        const isPants = handle === LOOK_PANTS_HANDLE;
        const isHoodie = /hoodie|sweater/i.test(handle + ' ' + titel);

        const wanted = [];
        if (!isPants) wanted.push(LOOK_PANTS_HANDLE);
        if (!isPants && !isHoodie) hoodieHandles(handle).forEach((h) => wanted.push(h));

        /* De optiewaarden van het artikel in de wagen: daar zit de kleur
           tussen. variant_options is taalonafhankelijk (alleen de waarden),
           options_with_values is de terugval. */
        const values =
          item.variant_options ||
          ((item.options_with_values || []).map((o) => (o && o.value) || '')) ||
          [];

        return Promise.all(wanted.map(lookFetch)).then((found) => {
          const out = [];
          found.forEach((product) => {
            if (!product || !product.id) return;
            if (inCart.indexOf(String(product.id)) !== -1) return;
            if (out.some((p) => String(p.id) === String(product.id))) return;
            if (out.length >= 2) return;
            /* De hoodie hoeft maar een keer: van de twee handles die we
               proberen bestaat er hooguit een. */
            product._rkColor = pickColor(product, values);
            out.push(product);
          });
          return out;
        });
      })
      .catch(() => []);
  }

  function buildCard(product, box) {
    const moneyFormat = box.dataset.rkMoneyFormat || '';
    const addLabel = box.dataset.rkAdd || 'Add';
    const soldOutLabel = box.dataset.rkSoldOut || '';

    const variants = (product.variants || []).filter((v) => v.available);
    if (!variants.length) return null;

    const card = document.createElement('div');
    card.className = 'rk-up__card';

    const media = document.createElement('a');
    media.className = 'rk-up__media';
    media.href = product.url;
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = '';

    /* De tegel is 78px breed, dus 200px is ruim zat - ook op een telefoon met
       drie keer zoveel pixels haalt de 400px van de 2x-regel dat makkelijk. */
    const sized = (src, w) => String(src).replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');

    function showImage(src) {
      if (!src) return;
      img.src = sized(src, 200);
      img.srcset = `${sized(src, 200)} 1x, ${sized(src, 400)} 2x`;
    }

    const shownSrc = product.featured_image || (product.images && product.images[0]) || '';
    showImage(shownSrc);
    media.appendChild(img);

    /*
      !! DE KLEUR DIE JE ZIET IS DE KLEUR DIE JE TOEVOEGT !!

      Gemeten in de winkel, bij DIEGO MARADONA (1986): op de kaart staat de
      hoofdfoto van het product - dat is daar "Faded Graphite" - terwijl de
      eerste variant in de lijst "Deep Black / S" is. Er stond dus een grijs
      shirt in beeld en er belandde een zwart shirt in de wagen. Precies wat
      Ramin zag: "als hij bruin shirt laat zien als foto, dan die toevoegen".

      Dus: zoek de variant die bij DEZE foto hoort en begin daarmee. Elke
      kleur heeft hier meerdere maten en die delen één variantfoto, dus we
      pakken de eerste leverbare maat van die kleur. Vergelijken gaat op de
      bestandsnaam: dezelfde foto komt in de JSON soms met een andere ?v=
      erachter terug. Vindt hij niets (een product zonder variantfoto's), dan
      blijft het de eerste variant - zoals het hiervoor altijd was.

      Andersom geldt het ook: kiest de klant zelf een andere kleur, dan
      verwisselt de foto mee (zie de change-handler onder het keuzevakje). Zo
      staan de foto en de keuze nooit meer los van elkaar.
    */
    const fileOf = (u) => String(u || '').split('?')[0].split('/').pop();
    const imgOf = (v) => (v && v.featured_image && (v.featured_image.src || v.featured_image)) || '';
    /*
      !! IS ER EEN KLEUR GEVRAAGD, DAN WINT DIE !!
      Zet lookCards hierboven een broek of hoodie in de rij, dan staat de
      gewenste kleur in product._rkColor. Die gaat voor op de foto-match
      hieronder: de kaart moet de kleur laten zien die bij het artikel in de
      wagen hoort, niet de hoofdfoto van het product.
    */
    const askedColor = product._rkColor || '';
    const askedIndex = askedColor ? colorIndexOf(colorNames(product)) : -1;
    const askedVariant =
      askedIndex >= 0
        ? variants.find((v) => String(v['option' + (askedIndex + 1)]) === String(askedColor))
        : null;

    const startVariant =
      askedVariant ||
      variants.find((v) => {
        const vf = fileOf(imgOf(v));
        return vf && vf === fileOf(shownSrc);
      }) ||
      variants[0];

    /*
      EN ANDERSOM: IS DE HOOFDFOTO GEEN VARIANTFOTO, DAN VOLGT DE FOTO DE
      VARIANT.
      Gemeten in de winkel: bij FOOTBALL HERITAGE (PELE) en INTER MILAN (2010)
      is de hoofdfoto een eigen opname die bij GEEN ENKELE kleur hoort - elke
      kleur heeft daar zijn eigen foto. Dan valt er hierboven niets te matchen
      en blijft het de eerste variant, en zou je dus nog steeds een andere
      kleur kunnen zien dan je toevoegt. Daarom zetten we hier de foto van de
      gekozen variant neer. Heeft die geen eigen foto (de truien bijvoorbeeld,
      die hebben alleen maten), dan blijft de hoofdfoto gewoon staan.
      Resultaat: wat je ziet en wat je toevoegt horen altijd bij elkaar.
    */
    showImage(imgOf(startVariant) || shownSrc);

    const info = document.createElement('div');
    info.className = 'rk-up__info';

    const title = document.createElement('a');
    title.className = 'rk-up__title';
    title.href = product.url;
    title.textContent = product.title;

    const price = document.createElement('div');
    price.className = 'rk-up__price';
    price.textContent = formatMoney(startVariant.price, moneyFormat);

    /*
      HET RONDE PLUSJE OP DE FOTO - EN WAT ER GEBEURT ALS JE EROP TIKT.

      Deze vorm (grote tegel, plusje rechtsonder, naam eronder) komt van
      icon-amsterdam.com, net als wat erachter zit: een tik op de tegel OF op
      het plusje opent geen nieuwe pagina maar een tweede lade over de
      winkelwagen heen, waarin je de kleur en de maat kiest en toevoegt. Zie
      qvOpen verderop in dit bestand.

      Hier stond eerst een onzichtbare <select> over het plusje: die opende de
      maatlijst van iOS en voegde meteen toe. Dat kan weg - in die productlade
      kiest de klant kleur EN maat, ziet hij de foto's en de prijs, en kan hij
      alsnog doorklikken naar de volledige pagina.

      preventDefault op de tegel is nodig omdat dat een echte link naar het
      product blijft: zo werkt openen in een nieuw tabblad en zoekmachine-
      indexering gewoon, maar een gewone tik opent de lade.
    */
    /*
      !! HET PLUSJE STAAT NAAST DE <a>, NIET ERIN !!
      De fototegel is een link naar het product. Een knop IN een link is geen
      geldige HTML en gedraagt zich er ook naar: een tik op het plusje telt dan
      ook als een tik op de link. Daarom zitten de link en het plusje allebei
      in dit tegel-blokje, met het plusje er via position: absolute overheen.
    */
    const tile = document.createElement('div');
    tile.className = 'rk-up__tile';
    tile.appendChild(media);

    const plus = document.createElement('div');
    plus.className = 'rk-up__plus';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rk-up__plus-btn';
    btn.setAttribute('aria-label', addLabel);
    btn.innerHTML = PLUS;
    plus.appendChild(btn);

    function openCard(event) {
      if (event) event.preventDefault();
      /* Met de kleur erbij: de lade opent op de kleur die op de kaart staat,
         zodat de klant alleen nog een maat hoeft te kiezen. */
      qvOpen(product.handle, product.title, askedColor);
    }

    btn.addEventListener('click', openCard);
    media.addEventListener('click', openCard);
    title.addEventListener('click', openCard);

    tile.appendChild(plus);

    info.appendChild(title);
    info.appendChild(price);

    /* ONDER ELKAAR: eerst de foto (met het plusje erin), daarna de naam en de
       prijs. De CSS hangt hieraan vast - .rk-up__card is nu een gewoon blok en
       geen grid met drie kolommen meer - dus zet hier niets naast elkaar
       zonder die mee te veranderen. */
    card.appendChild(tile);
    card.appendChild(info);
    return card;
  }

  /* RK: de opgehaalde aanbevelingen per startproduct onthouden.

     Waarom dit moet: bij elke plus of min vervangt Dawn de HELE .drawer__inner,
     dus ook het upsell-blok. Zonder geheugen werd er elke keer opnieuw een
     verzoek gedaan en ploften de kaartjes een halve seconde later alsnog in
     beeld - een zichtbare sprong na iedere klik. Met dit geheugen staan ze er
     meteen, zonder netwerkverkeer. */
  const recoCache = Object.create(null);

  function fillUpsell(box, track, products) {
    let shown = 0;
    products.forEach((p) => {
      const card = buildCard(p, box);
      if (card) {
        track.appendChild(card);
        shown += 1;
      }
    });

    if (!shown) return;

    box.hidden = false;
    if (shown > 1) box.setAttribute('data-rk-many', '');

    const prev = box.querySelector('.rk-up__nav--prev');
    const next = box.querySelector('.rk-up__nav--next');
    if (prev) prev.innerHTML = ARROW_PREV;
    if (next) next.innerHTML = ARROW_NEXT;
    if (!prev || !next) return;

    /*
      EEN STAP IS EEN HELE KAART PLUS DE TUSSENRUIMTE.
      Niet track.clientWidth: de kaart is even breed als de bak, maar er zit
      10px gap tussen twee kaarten (zie .rk-up__track in de CSS). Schuif je
      precies clientWidth op, dan kom je elke keer 10px tekort en staat na een
      paar tikken de vorige kaart half in beeld. De gap lezen we uit de CSS
      zelf, zodat hij maar op één plek staat.
    */
    function step() {
      const first = track.firstElementChild;
      if (!first) return track.clientWidth || 1;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    /*
      DE PIJLTJES GAAN UIT AAN HET BEGIN EN AAN HET EINDE.
      Dit hangt aan het scroll-event en niet alleen aan de kliks, zodat het
      ook klopt als iemand zelf veegt. De speling van 2px is er omdat een
      browser bij vloeiend schuiven en bij een scherm met halve pixels net
      niet op een rond getal uitkomt; zonder die speling blijft het pijltje
      aan het einde soms aan staan.
    */
    function sync() {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function initUpsell(box) {
    if (!box || box.hasAttribute('data-rk-up-ready')) return;
    box.setAttribute('data-rk-up-ready', '');

    /*
      !! GEEN CHANGE-EVENT UIT DIT BLOK LATEN ONTSNAPPEN !!

      Dit blok staat sinds de lade van onderaf vastzit BINNEN
      <cart-drawer-items> - de artikelen en dit blok schuiven samen, zie het
      comment in snippets/cart-drawer.liquid. Maar CartItems uit
      assets/cart.js luistert op dat element ZELF naar change, en het
      keuzemenu hieronder zendt dat ook uit. Zonder deze rem ziet Dawn die
      kleurkeuze aan voor een aantalswijziging: validateQuantity() leest dan
      event.target.dataset.index, dat bestaat niet op een upsell-select, en
      daarna gaat updateQuantity(undefined, NaN) de deur uit - en dat eindigt
      in "je winkelwagen kon niet worden bijgewerkt".

      Daarom hier, op het blok zelf, elk change- en input-event tegenhouden.
      Onze eigen luisteraar zit op de select zelf en heeft er dus geen last
      van; alles wat verder omhoog zou borrelen stopt hier.
    */
    ['change', 'input'].forEach((name) => {
      box.addEventListener(name, (event) => event.stopPropagation());
    });

    const track = box.querySelector('[data-rk-up-track]');
    const seedId = box.dataset.rkSeed;
    const inCart = (box.dataset.rkInCart || '').split(',').filter(Boolean);
    if (!track || !seedId) return;

    /* De broek en de hoodie die wij er zelf voor zetten mogen daarna niet
       nog eens uit de aanbevelingen komen - vandaar dat hun id's hier
       meegefilterd worden. */
    const voorop = [];
    const keep = (list) =>
      list.filter(
        (p) =>
          inCart.indexOf(String(p.id)) === -1 &&
          !voorop.some((q) => String(q.id) === String(p.id))
      );

    const url = `${shopRoot()}recommendations/products.json?product_id=${encodeURIComponent(
      seedId
    )}&limit=10&intent=related`;

    /* Eerst de twee eigen kaarten, dan pas vullen - anders staat de rij er
       twee keer in een iets andere volgorde. Allebei de bronnen worden
       onthouden (lookCache en recoCache), dus na de eerste keer gaat dit
       zonder netwerk en dus zonder sprong na elke plus/min. */
    lookCards(inCart)
      .then((cards) => {
        cards.forEach((c) => voorop.push(c));

        if (recoCache[seedId]) {
          fillUpsell(box, track, voorop.concat(keep(recoCache[seedId])));
          return;
        }

        return fetch(url, { credentials: 'same-origin' })
          .then((res) => res.json())
          .then((data) => {
            const all = data && data.products ? data.products : [];
            recoCache[seedId] = all;
            fillUpsell(box, track, voorop.concat(keep(all)));
          })
          .catch(() => {
            /* Geen aanbevelingen? Dan staan de eigen kaarten er in elk geval. */
            if (voorop.length) fillUpsell(box, track, voorop);
          });
      })
      .catch(() => {
        /* Stil falen: zonder aanbevelingen blijft het blok simpelweg verborgen. */
      });
  }

  /* ----------------------------------------------------------
     DE SCHUIFSTAND VASTHOUDEN

     Dawn vervangt bij elke plus/min de hele binnenkant van de lade. De
     schuifbak is daarna een VERS element en begint dus bovenaan. Stond je bij
     het derde artikel, dan sprong je na één klik op de plus terug naar het
     eerste - en dat voelt alsof de lade op hol slaat.
     We onthouden hoe ver er geschoven was en zetten dat na de verversing
     terug. Eén keer per verse kopie (vlag data-rk-scroll-ready), zodat we
     nooit tegen het scrollen van de bezoeker zelf in duwen.

     De schuifbak is <cart-drawer-items> zelf (zoals Dawn het bedoelt). Er zat
     een eigen wikkel omheen; die is eruit omdat sections/rk-cart.liquid zijn
     vinkjes-blok met insertBefore pal vóór cart-drawer-items zet en dat
     alleen kan als dat een direct kind van .drawer__inner is. Zie het
     comment in snippets/cart-drawer.liquid.
     ---------------------------------------------------------- */
  let keptScrollTop = 0;

  function initScroll(box) {
    if (!box || box.hasAttribute('data-rk-scroll-ready')) return;
    box.setAttribute('data-rk-scroll-ready', '');

    if (keptScrollTop > 0 && box.scrollTop === 0) {
      /* Na de volgende tekenbeurt, anders is de hoogte nog niet bekend en
         knipt de browser onze waarde af tot 0. */
      window.requestAnimationFrame(() => {
        box.scrollTop = keptScrollTop;
      });
    }

    box.addEventListener(
      'scroll',
      () => {
        keptScrollTop = box.scrollTop;
      },
      { passive: true }
    );
  }

  /* ----------------------------------------------------------
     AANHAKEN - ook na elke verversing

     Dawn vervangt bij elke plus/min de complete .drawer__inner, dus de
     elementen waar we hierboven aan hangen zijn daarna weg. Een waarnemer op
     de lade hangt ze opnieuw aan. De vlaggen data-rk-up-ready /
     data-rk-scroll-ready zorgen dat dat precies één keer per verse kopie
     gebeurt, dus de waarnemer kan niet op zijn eigen wijziging blijven
     reageren.
     ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     MIN BLIJVEN DRUKKEN TOT 0 = PRODUCT ERUIT

     Ramin: "als je gewoon steeds min drukt totdat het 0 wordt moet het
     product uit je cart gewoon" - in de lade EN op de /cart-pagina.

     Waarom wij dit zelf doen en niet aan Dawn overlaten: de min-knop zit in
     <quantity-input> uit assets/global.js. Die doet stepDown() op het
     invoerveld en zet daarna, als je op het minimum stond, de waarde terug
     naar input.min. Of je daarmee echt op 0 uitkomt hangt af van drie
     attributen die Shopify per variant invult (min, data-min en step), en die
     liepen hier niet overal gelijk. Dus doen we het expliciet: sta je op 1 en
     druk je op min, dan gaat de regel eruit.

     Dit luistert op het document in de CAPTURE-fase, dus voordat de knop zijn
     eigen afhandeling krijgt; stopPropagation houdt die er daarna buiten,
     zodat er geen tweede wijziging overheen kan komen. Het verwijderen zelf
     laten we Dawn doen - updateQuantity met 0, precies wat het prullenbakje
     ook doet - zodat de lade, de /cart-pagina en de foutmeldingen allemaal op
     dezelfde manier bijwerken.

     Dit bestand wordt op elke pagina geladen (snippets/cart-drawer.liquid
     staat in layout/theme.liquid), dus deze ene luisteraar dekt allebei de
     winkelwagens.
     ---------------------------------------------------------- */
  function initRemoveAtZero() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!target || !target.closest) return;

        const btn = target.closest('button[name="minus"]');
        if (!btn || !btn.closest('quantity-input')) return;

        const input = btn.closest('quantity-input').querySelector('.quantity__input');
        if (!input) return;

        /* Boven de 1 doet Dawn gewoon zijn werk. */
        if (parseInt(input.value, 10) > 1) return;

        const host = btn.closest('cart-drawer-items, cart-items');
        const index = input.dataset.index;
        if (!host || !index || typeof host.updateQuantity !== 'function') return;

        event.preventDefault();
        event.stopPropagation();
        host.updateQuantity(index, 0);
      },
      true
    );
  }


  /* ----------------------------------------------------------
     DE PRODUCTLADE (SNELBEKIJKEN)

     Ramin zag bij icon-amsterdam.com dat een tik op een aanbeveling geen
     nieuwe pagina opent, maar een tweede lade over de winkelwagen heen:
     foto's met een teller, de naam, de prijs, de kleurbolletjes, de maten,
     een toevoegen-knop, de beschrijving en onderaan een link naar de volledige
     pagina. "dat is heel nice kan je dat doen".

     WAAROM DIT BETER IS DAN DOORKLIKKEN
     Wie vanuit zijn winkelwagen naar een productpagina gaat, verlaat de
     winkelwagen. Hier blijft de wagen gewoon openstaan: je kiest je maat,
     voegt toe, en staat meteen weer in je wagen - nu met twee artikelen.

     HOE HET IN ELKAAR ZIT
     - De lege lade staat in snippets/cart-drawer.liquid, naast <cart-drawer>
       en dus NIET erin: Dawn vervangt bij elke wijziging de complete
       .drawer__inner, en alles wat daarbinnen staat zou dan middenin het
       kiezen onder je handen worden weggegooid.
     - De inhoud komt uit /products/<handle>.js - dezelfde gegevens die de
       productpagina gebruikt, dus ook dezelfde vertaalde optienamen
       ("Color"/"Kleur") en dezelfde prijzen per variant.
     - De kleurbolletjes lezen window.RK_COLORS, de winkelbrede lijst
       "kleurnaam = hexcode" uit snippets/rk-colors.liquid. Precies dezelfde
       bron als de bolletjes op de productkaarten, dus een kleur ziet er
       overal hetzelfde uit. Staat een naam er niet in, dan komt er geen
       bolletje maar een knop met de naam erop - nooit een verkeerde kleur.
     ---------------------------------------------------------- */
  /* De opgehaalde producten onthouden: tik je twee keer op hetzelfde product,
     dan staat het de tweede keer meteen in beeld. */
  const qvCache = Object.create(null);

  function qvRoot() {
    return document.querySelector('[data-rk-quickview]');
  }

  function qvOpen(handle, fallbackTitle, preferColor) {
    const root = qvRoot();
    if (!root || !handle) return;

    /* De kleur waarop de lade moet openen (zie lookCards). Leeg = gewoon de
       eerste leverbare variant, zoals het altijd was. Hij staat op het
       element en niet in een variabele, omdat qvFill ook uit de cache
       aangeroepen wordt. */
    root.dataset.rkQvColor = preferColor || '';

    const head = root.querySelector('[data-rk-qv-title]');
    const body = root.querySelector('[data-rk-qv-body]');
    if (head) head.textContent = fallbackTitle || '';
    if (body) body.innerHTML = '<div class="rk-qv__loading" aria-hidden="true"></div>';

    root.hidden = false;
    root.removeAttribute('aria-hidden');
    /* Een tel later de klasse erop, anders slaat de browser de overgang over:
       hij moet het element eerst in zijn verborgen stand hebben getekend. */
    window.requestAnimationFrame(() => root.classList.add('is-open'));

    const close = root.querySelector('[data-rk-qv-close]');
    if (close) close.focus();

    /*
      !! HET MERKJE MOET VÓÓR HET OPHALEN STAAN - NIET ERNA !!
      Hieronder wordt gecontroleerd of het antwoord nog over DIT product gaat;
      iemand kan intussen op een andere tegel hebben getikt. Dat merkje stond
      eerst onderaan deze functie, en er werd ook nog gecontroleerd op de
      klasse is-open - die er pas een beeldje later op komt (zie de
      requestAnimationFrame hierboven). Op een snelle verbinding was het
      antwoord er eerder dan dat beeldje, en dan bleef de lade leeg. In de
      testopstelling (met een onmiddellijk antwoord) gebeurde dat elke keer.
    */
    root.dataset.rkQvHandle = handle;

    if (qvCache[handle]) {
      qvFill(qvCache[handle]);
      return;
    }

    fetch(`${shopRoot()}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then((res) => {
        if (!res.ok) throw new Error('rk');
        return res.json();
      })
      .then((product) => {
        qvCache[handle] = product;
        if (root.dataset.rkQvHandle === handle) qvFill(product);
      })
      .catch(() => {
        if (body) {
          body.innerHTML = '';
          const link = document.createElement('a');
          link.className = 'rk-qv__full';
          link.href = `${shopRoot()}products/${handle}`;
          link.textContent = root.dataset.rkQvFull || '';
          body.appendChild(link);
        }
      });
  }

  function qvClose() {
    const root = qvRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    /* Pas verbergen als de schuifbeweging klaar is; 240ms is de duur uit de
       CSS. Staat hij meteen op hidden, dan knalt hij weg in plaats van weg te
       schuiven. */
    window.setTimeout(() => {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 240);
  }

  /* De kleurnaam opzoeken in de winkelbrede lijst. Langste naam eerst, zodat
     "vintage black" voorgaat op "black" - dezelfde volgorde als op de
     productpagina en de productkaart. */
  function qvColor(name) {
    const map = window.RK_COLORS;
    if (!map || !name) return '';
    const needle = String(name).toLowerCase();
    let best = '';
    Object.keys(map).forEach((key) => {
      if (needle.indexOf(key) !== -1 && key.length > best.length) best = key;
    });
    return best ? map[best] : '';
  }

  function qvFill(product) {
    const root = qvRoot();
    const body = root && root.querySelector('[data-rk-qv-body]');
    if (!root || !body) return;

    const head = root.querySelector('[data-rk-qv-title]');
    if (head) head.textContent = product.title || '';

    const moneyFormat = root.dataset.rkMoneyFormat || '';
    const addLabel = root.dataset.rkAdd || '';
    const soldOutLabel = root.dataset.rkSoldOut || '';

    body.innerHTML = '';

    /* ---- de foto's ---- */
    const images = (product.images || []).slice(0, 20);
    const gallery = document.createElement('div');
    gallery.className = 'rk-qv__gallery';

    const track = document.createElement('div');
    track.className = 'rk-qv__track';
    images.forEach((src, i) => {
      const cell = document.createElement('div');
      cell.className = 'rk-qv__shot';
      const img = document.createElement('img');
      img.alt = '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.src = String(src).replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2');
      img.srcset = `${String(src).replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2')} 1x, ${String(src).replace(
        /(\.[a-z]+)(\?|$)/i,
        '_1200x$1$2'
      )} 2x`;
      cell.appendChild(img);
      track.appendChild(cell);
    });
    gallery.appendChild(track);
    body.appendChild(gallery);

    /* ---- de teller met de twee pijltjes ---- */
    const navBar = document.createElement('div');
    navBar.className = 'rk-qv__nav';
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'rk-qv__arrow';
    prev.setAttribute('aria-label', root.dataset.rkPrev || '');
    prev.innerHTML = ARROW_PREV;
    const count = document.createElement('span');
    count.className = 'rk-qv__count';
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'rk-qv__arrow';
    next.setAttribute('aria-label', root.dataset.rkNext || '');
    next.innerHTML = ARROW_NEXT;
    navBar.appendChild(prev);
    navBar.appendChild(count);
    navBar.appendChild(next);
    if (images.length > 1) body.appendChild(navBar);

    function shotAt() {
      const w = track.clientWidth || 1;
      return Math.min(images.length, Math.max(1, Math.round(track.scrollLeft / w) + 1));
    }
    function syncCount() {
      count.textContent = `${shotAt()} / ${images.length}`;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    track.addEventListener('scroll', syncCount, { passive: true });
    syncCount();

    /* ---- naam en prijs ---- */
    const title = document.createElement('p');
    title.className = 'rk-qv__title';
    title.textContent = product.title || '';
    body.appendChild(title);

    const price = document.createElement('p');
    price.className = 'rk-qv__price';
    body.appendChild(price);

    /* ---- de keuzes ---- */
    const variants = (product.variants || []).filter((v) => v);

    /*
      !! product.options ZIJN OBJECTEN, GEEN TEKST !!
      /products/<handle>.js geeft per optie { name, position, values } terug.
      Hier stond gewoon product.options, en dus stond er in de lade
      "[OBJECT OBJECT]: WHITE T-SHIRT" in plaats van "COLOR: WHITE T-SHIRT".
      Ramin zag het meteen. In de aanbevelingen-JSON
      (/recommendations/products.json) zijn het wél losse woorden, vandaar dat
      het daar nooit opviel - reken er dus niet op dat die twee hetzelfde
      teruggeven.
    */
    const options = (product.options || []).map((o) => (o && typeof o === 'object' ? o.name : o));
    const chosen = [];

    function variantFor() {
      return variants.find((v) =>
        options.every((o, i) => !chosen[i] || String(v['option' + (i + 1)]) === String(chosen[i]))
      );
    }

    /* Kan deze waarde op deze plek nog, gegeven wat er al gekozen is? Zo niet,
       dan gaat de knop uit in plaats van dat je op een dood einde klikt. */
    function possible(index, value) {
      return variants.some((v) => {
        if (String(v['option' + (index + 1)]) !== String(value)) return false;
        if (!v.available) return false;
        return options.every((o, i) => i === index || !chosen[i] || String(v['option' + (i + 1)]) === String(chosen[i]));
      });
    }

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'rk-qv__add';

    function paintPrice() {
      const v = variantFor();
      price.textContent = '';
      if (!v) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const was = document.createElement('s');
        was.className = 'rk-qv__was';
        was.textContent = formatMoney(v.compare_at_price, moneyFormat);
        price.appendChild(was);
      }
      const now = document.createElement('span');
      now.className = 'rk-qv__now';
      now.textContent = formatMoney(v.price, moneyFormat);
      price.appendChild(now);
    }

    function paintAdd() {
      const v = variantFor();
      const compleet = options.every((o, i) => chosen[i]);
      add.textContent = v && !v.available ? soldOutLabel || addLabel : addLabel;
      add.disabled = !compleet || !v || !v.available;
    }

    const groups = [];
    options.forEach((name, index) => {
      const waarden = [];
      variants.forEach((v) => {
        const value = v['option' + (index + 1)];
        if (value && waarden.indexOf(value) === -1) waarden.push(value);
      });
      if (!waarden.length) return;

      const group = document.createElement('div');
      group.className = 'rk-qv__opt';

      const label = document.createElement('p');
      label.className = 'rk-qv__opt-label';
      group.appendChild(label);

      const row = document.createElement('div');
      row.className = 'rk-qv__values';
      group.appendChild(row);

      /*
        DRIE MANIEREN OM EEN OPTIE TE TONEN, IN DEZE VOLGORDE:

        1. FOTOTEGELS - als elke waarde een eigen variantfoto heeft. Dat is wat
           Ramin wilde: "doe gwn die product fotos zoals op product pagina ipv
           die kleurbollen". Het is ook eerlijker: bij hem heet een kleur
           "White T-Shirt" of "Vintage Graphite", en dan zegt de foto van het
           shirt meer dan een bolletje.
        2. KLEURBOLLETJES - als er geen variantfoto's zijn maar de naam wel in
           de winkelbrede kleurenlijst staat (window.RK_COLORS).
        3. KNOPJES MET DE NAAM EROP - al het andere, en dus altijd de maten.
      */
      const beelden = {};
      waarden.forEach((value) => {
        const v = variants.find(
          (x) => String(x['option' + (index + 1)]) === String(value) && x.featured_image && x.featured_image.src
        );
        if (v) beelden[value] = v.featured_image.src;
      });

      /*
        Alleen de EERSTE optie krijgt fototegels, en alleen als elke waarde
        een EIGEN foto heeft. Dat is dezelfde afspraak als op de
        productpagina: daar krijgt alleen de eerste optie (de kleur) de grote
        vierkante tegels en zijn alle andere opties gewone knoppen.
        Zonder de tweede voorwaarde kregen de MATEN ook tegels: elke maat
        hoort immers bij een variant, en die variant heeft een foto - maar dat
        is voor S, M en L dezelfde foto. Vijf keer hetzelfde shirt naast elkaar
        zegt niets. Daarom tellen we of de foto's ook echt van elkaar
        verschillen.
      */
      const uniekeBeelden = {};
      Object.keys(beelden).forEach((k) => {
        uniekeBeelden[beelden[k]] = true;
      });
      const metFoto =
        index === 0 &&
        waarden.every((value) => beelden[value]) &&
        Object.keys(uniekeBeelden).length === waarden.length;
      const isKleur = !metFoto && !!qvColor(waarden[0]);
      if (metFoto) row.classList.add('rk-qv__values--tiles');
      if (isKleur) row.classList.add('rk-qv__values--dots');

      const knoppen = waarden.map((value) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = metFoto ? 'rk-qv__swatch' : isKleur ? 'rk-qv__dot' : 'rk-qv__chip';
        if (metFoto) {
          const img = document.createElement('img');
          img.loading = 'lazy';
          img.alt = '';
          img.src = String(beelden[value]).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
          btn.appendChild(img);
          btn.setAttribute('aria-label', value);
        } else if (isKleur) {
          const hex = qvColor(value);
          btn.style.setProperty('--rk-dot', hex || '#ffffff');
          btn.setAttribute('aria-label', value);
        } else {
          btn.textContent = value;
        }
        btn.addEventListener('click', () => {
          chosen[index] = value;
          /* Een andere kleur kan andere maten hebben. Wat nog steeds kan laten
             we staan - koos je M en bestaat M ook in de nieuwe kleur, dan hoef
             je niet opnieuw te kiezen. Alleen wat onmogelijk is geworden gaat
             eruit. */
          for (let i = index + 1; i < options.length; i++) {
            if (chosen[i] && !possible(i, chosen[i])) chosen[i] = null;
          }
          paintAll();
          const v = variantFor();
          if (v && v.featured_image && v.featured_image.src) qvScrollToImage(track, images, v.featured_image.src);
        });
        row.appendChild(btn);
        return { value: value, el: btn };
      });

      groups.push({ index: index, name: name, label: label, knoppen: knoppen });
      body.appendChild(group);
    });

    function paintAll() {
      groups.forEach((g) => {
        const gekozen = chosen[g.index];
        g.label.textContent = gekozen ? `${g.name}: ${gekozen}` : g.name;
        g.knoppen.forEach((k) => {
          const kan = possible(g.index, k.value);
          k.el.classList.toggle('is-on', String(gekozen) === String(k.value));
          k.el.classList.toggle('is-off', !kan);
          k.el.disabled = !kan;
        });
      });
      paintPrice();
      paintAdd();
    }

    /* Beginnen bij de eerste leverbare variant, net als de kaart in de
       winkelwagen doet - tenzij er een kleur is meegegeven (zie qvOpen): dan
       staat die kleur meteen aan en hoeft de klant alleen nog een maat. */
    const wantColor = (root.dataset.rkQvColor || '').trim();
    const wantIndex = wantColor ? colorIndexOf(options) : -1;
    const wantVariant =
      wantIndex >= 0
        ? variants.find((v) => v.available && String(v['option' + (wantIndex + 1)]) === String(wantColor))
        : null;
    const start = wantVariant || variants.find((v) => v.available) || variants[0];
    if (start) options.forEach((o, i) => { chosen[i] = start['option' + (i + 1)]; });
    paintAll();
    if (start && start.featured_image && start.featured_image.src) {
      qvScrollToImage(track, images, start.featured_image.src);
    }

    /* ---- toevoegen ---- */
    add.addEventListener('click', () => {
      const v = variantFor();
      if (!v) return;
      add.disabled = true;
      fetch(`${shopRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        /* properties = het verborgen merkje voor de meting, zie METING bovenaan. */
        body: JSON.stringify({ items: [{ id: Number(v.id), quantity: 1, properties: UPSELL_SOURCE }] }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.status && data.status !== 200) {
            add.textContent = soldOutLabel || addLabel;
            add.disabled = false;
            return;
          }
          /* Dicht en de wagen bijwerken: je staat meteen weer in je
             winkelwagen, nu met dit artikel erin. */
          qvClose();
          return refresh();
        })
        .catch(() => {
          add.disabled = false;
        });
    });
    body.appendChild(add);

    /* ---- de beschrijving, dichtgeklapt ---- */
    if (product.description) {
      const acc = document.createElement('details');
      acc.className = 'rk-qv__acc';
      const sum = document.createElement('summary');
      sum.textContent = root.dataset.rkDescription || '';
      acc.appendChild(sum);
      const tekst = document.createElement('div');
      tekst.className = 'rk-qv__acc-body';
      tekst.innerHTML = product.description;
      acc.appendChild(tekst);
      body.appendChild(acc);
    }

    /* ---- naar de volledige pagina ---- */
    const full = document.createElement('a');
    full.className = 'rk-qv__full';
    full.href = `${shopRoot()}products/${product.handle}`;
    full.textContent = root.dataset.rkQvFull || '';
    body.appendChild(full);
  }

  /* De galerij naar de foto van de gekozen variant schuiven. Vergelijken gaat
     op de bestandsnaam: dezelfde foto komt soms met een andere ?v= terug. */
  function qvScrollToImage(track, images, src) {
    const file = (u) => String(u || '').split('?')[0].split('/').pop();
    const doel = file(src);
    const i = images.findIndex((img) => file(img) === doel);
    if (i < 0) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
  }

  function initQuickView() {
    const root = qvRoot();
    if (!root || root.hasAttribute('data-rk-qv-ready')) return;
    root.setAttribute('data-rk-qv-ready', '');

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-rk-qv-close]')) qvClose();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) qvClose();
    });
  }

  /* ----------------------------------------------------------
     COMPLETE THE LOOK OP DE PRODUCTPAGINA OPENT DEZELFDE LADE

     Ramin: "ik wil als je add klikt of op de titel of foto dat je naar zo een
     page gaat als wat je hebt gedaan voor often bought together in de cart" -
     dus precies de lade hierboven, nu ook onder het blok COMPLETE THE LOOK op
     de productpagina.

     Dat blok staat als eigen blok in sections/main-product.liquid en levert
     per aanbeveling een .rk-look__item met daarin een fotolink
     (.rk-look__thumb), een titellink (.rk-look__title), de maatknopjes en een
     toevoegen-knop (.rk-look__add). We haken hier aan in plaats van in dat
     blok zelf, om één reden: de lade en alles wat haar vult staan in dit
     bestand en dit bestand wordt op elke pagina geladen (zie het comment bij
     MIN BLIJVEN DRUKKEN). Zo blijft er één plek waar die lade woont.

     WAAROM DE CAPTURE-FASE MET stopPropagation
     De toevoegen-knop heeft zijn eigen afhandeling: die legt het artikel
     meteen in de wagen. Die mag nu niet ook nog afgaan, anders komt er iets
     in de wagen terwijl de lade opengaat. In de capture-fase zijn we eerder
     dan de knop zelf, en stopPropagation houdt hem daarna buiten de deur -
     net als bij min-tot-nul hierboven.

     preventDefault is voor de twee links: dat blijven echte links naar het
     product, zodat openen in een nieuw tabblad en zoekmachines gewoon werken,
     maar een gewone tik opent de lade.

     DE MAATKNOPJES IN DE RIJ LATEN WE MET RUST. Wie daar een maat kiest en
     dan op toevoegen tikt, kiest 'm zo nodig opnieuw in de lade; daar staat
     ook de kleur, de prijs en wat er op voorraad is.
     ---------------------------------------------------------- */
  function initLook() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!target || !target.closest) return;

        const hook = target.closest('.rk-look__thumb, .rk-look__title, .rk-look__add');
        if (!hook) return;

        const item = hook.closest('.rk-look__item');
        if (!item) return;

        /* De handle staat in de link van de foto of de titel:
           /products/<handle>, met taalvoorvoegsel ervoor op de vertaalde
           pagina's (/nl/products/<handle>). Daarom knippen we op /products/
           en niet op de schuine streep. */
        const link = item.querySelector('a.rk-look__title[href], a.rk-look__thumb[href]');
        const href = link ? link.getAttribute('href') || '' : '';
        const parts = href.split('?')[0].split('/products/');
        const handle = parts.length > 1 ? parts[1] : '';
        if (!handle) return;

        /* Geen lade in de pagina (zou niet moeten kunnen), dan laten we de link
           gewoon zijn werk doen in plaats van de klant op niets te laten
           klikken. */
        if (!qvRoot()) return;

        const titleEl = item.querySelector('.rk-look__title');

        event.preventDefault();
        event.stopPropagation();
        qvOpen(handle, titleEl ? titleEl.textContent.trim() : '');
      },
      true
    );
  }

  function wire() {
    document.querySelectorAll('cart-drawer-items').forEach(initScroll);
    document.querySelectorAll('[data-rk-upsell]').forEach(initUpsell);
  }

  function throttled(fn) {
    let id = 0;
    return function () {
      if (id) return;
      id = window.requestAnimationFrame(() => {
        id = 0;
        fn();
      });
    };
  }

  function start() {
    wire();
    initRemoveAtZero();
    initQuickView();
    initLook();

    const drawer = document.querySelector(SEL_ROOT);
    if (drawer && window.MutationObserver) {
      new MutationObserver(throttled(wire)).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
